// extracted by mini-css-extract-plugin
export default {"container":"afiZLA","cards":"tfCiE0"};